import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/Home'
import MyPage from '@/components/MyPage'
import Detail from '@/components/Detail'
import TreeD3 from '@/components/TreeD3'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(Router)

export default new Router({
  // scrollBehavior (to, from, savedPosition) {
  //   return { x: 0, y: 0 };
  // },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/MyPage',
      name: 'MyPage',
      component: MyPage
    },
    {
      path: '/LIFE',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/tree',
      name: 'TreeD3',
      component: TreeD3
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js